import { render } from "./CardsComponent.vue?vue&type=template&id=b9e3b3de&scoped=true"
const script = {}

import "./CardsComponent.vue?vue&type=style&index=0&id=b9e3b3de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9e3b3de"]])

export default __exports__